'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExploreMapV1 = exports.mapDispatchToProps = exports.mapStateToProps = exports.ExploreMapV1Unwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Sagas = require('decorators/Sagas/Sagas');

var _decorator = require('helpers/decorator');

var _bound = require('redux/saga/entities/bound');

var _locale = require('redux/modules/locale');

var _CallToAction = require('components/CallToAction');

var _Map = require('./Map');

var _exploreMapV = require('./exploreMapV1.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-constant-condition, no-nested-ternary */
/* globals L: true */

var ExploreMapV1Unwrapped = exports.ExploreMapV1Unwrapped = function (_Component) {
  (0, _inherits3.default)(ExploreMapV1Unwrapped, _Component);

  function ExploreMapV1Unwrapped(props) {
    (0, _classCallCheck3.default)(this, ExploreMapV1Unwrapped);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExploreMapV1Unwrapped.__proto__ || (0, _getPrototypeOf2.default)(ExploreMapV1Unwrapped)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);

    _this.$map = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(ExploreMapV1Unwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          loadVenues = _props.loadVenues,
          location = _props.location;

      loadVenues(location);
    }
  }, {
    key: 'createLeafletBounds',
    value: function createLeafletBounds() {
      var _L;

      var snapLocation = this.props.snapLocation;


      if (!snapLocation) {
        return;
      }

      var _snapLocation$split = snapLocation.split(','),
          _snapLocation$split2 = (0, _slicedToArray3.default)(_snapLocation$split, 4),
          southwestLat = _snapLocation$split2[0],
          southwestLng = _snapLocation$split2[1],
          northeastLat = _snapLocation$split2[2],
          northeastLng = _snapLocation$split2[3];

      var boundsAsArray = [[southwestLat, southwestLng], [northeastLat, northeastLng]];

      return __SERVER__ || __TEST__ ? boundsAsArray : (_L = L).latLngBounds.apply(_L, boundsAsArray);
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.props.onClick();
    }
  }, {
    key: 'render',
    value: function render() {
      var venues = this.props.venues;


      return _react2.default.createElement(
        'section',
        { className: 'explore-map-v1' },
        _react2.default.createElement(
          'div',
          {
            onClick: this.handleClick
          },
          _react2.default.createElement(_Map.Map, {
            ref: this.$map,
            venues: venues,
            mapBounds: this.createLeafletBounds()
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'explore-map-v1__cta' },
          _react2.default.createElement(
            _CallToAction.CallToAction,
            {
              action: _CallToAction.ACTIONS.LINK,
              color: 'tertiary',
              extraClass: 'bt--lg explore-map-v1__cta__bt',
              to: '/explore'
            },
            'Explore your area'
          )
        )
      );
    }
  }]);
  return ExploreMapV1Unwrapped;
}(_react.Component);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var location = (0, _locale.selectUserLocation)(state);
  var snapLocation = state.features.explore.snapLocation;

  var venuesData = _bound.nearbyPopularVenues.data(state, (0, _exploreMapV.nearbyVenuesKey)(location));

  return {
    location: location,
    snapLocation: snapLocation,
    venues: venuesData ? venuesData.venues : []
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  loadVenues: _exploreMapV.loadVenues,
  onClick: _exploreMapV.ctaClick
};

ExploreMapV1Unwrapped.propTypes = {
  loadVenues: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    lat: _propTypes2.default.number.isRequired,
    lon: _propTypes2.default.number.isRequired
  }),
  snapLocation: _propTypes2.default.string,
  venues: _propTypes2.default.array,
  onClick: _propTypes2.default.func.isRequired
};

var ExploreMapV1 = exports.ExploreMapV1 = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({ watch: _exploreMapV.watchSaga }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(ExploreMapV1Unwrapped);